import { useState } from "react";
import { addDoc, collection, getDocs } from "firebase/firestore";
import { db } from "../../../Firebase/Config";
import RouteWithTitle from '../../../Layout/RouteWithTitle';
import Header from "./Header/Header";
import Loading from "../Loading/Loading";

function Contect() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [firstandlastname, setFirstnameAndLastname] = useState();
  const [email, setEamil] = useState();
  const [subject, setSubject] = useState();
  const [message, setMessage] = useState();

  function handelFirstnameAndLastname(event) {
    setFirstnameAndLastname(event.target.value);
  }

  function handleEmail(event) {
    setEamil(event.target.value);
  }

  function handleSubject(event) {
    setSubject(event.target.value);
  }

  function handleMessage(event) {
    setMessage(event.target.value);
  }

  async function onSubmit(event) {
    event.preventDefault();

    const data = {
      FirstAndLastname: firstandlastname,
      Email: email,
      Subject: subject,
      Message: message,
    };

    try {
      setLoading(true);
      const ref = collection(db, "contect");
      const snapshot = await getDocs(ref);
      const Id = snapshot.size + 1;
      data.Id = Id;

      await addDoc(ref, data);
      setError("پیام شما با موفقیت ارسال شد");
    } catch (error) {
      setError("خطایی رخ داده است");
    } finally {
      setLoading(false);
    }
  }

  return (
    <RouteWithTitle>
    <div className="Container">
      <div id="contact" className="py-20">
        <Header />
        <div className="bg-white pt-24">
          <form
            action=""
            className="sm:flex-row xl:flex flex-col justify-between gap-4"
            dir="rtl"
          >
            <div className="xl:w-1/2 sm:w-full">
              <input
                className="input"
                type="text"
                placeholder="نام و نام خانوادگی"
                value={firstandlastname}
                onChange={handelFirstnameAndLastname}
              />
              <input
                className="input"
                type="email"
                placeholder="آدرس ایمیل"
                value={email}
                onChange={handleEmail}
              />
              <input
                className="input"
                type="text"
                placeholder="موضوع پیام"
                value={subject}
                onChange={handleSubject}
              />
            </div>
            <div
              className="xl:w-1/2 main-contact-main-box2 sm:w-full"
              dir="ltr"
            >
              <textarea
                className="outline-none transition-all w-full h-52 p-4 resize-none border focus:border-custom_blue"
                dir="rtl"
                placeholder="پیغام"
                value={message}
                onChange={handleMessage}
              ></textarea>
              <button
                className="w-full sm:w-auto xl:text-lg px-8 py-3 mt-4 rounded-3xl border-none text-white flex justify-center items-center font-medium cursor-pointer bg-slate-600"
                dir="rtl"
                onClick={onSubmit}
              >
                <i className="bx bx-left-arrow-alt text-xl ml-2"></i>ارسال پیام
              </button>
            </div>
          </form>
          {loading ? (
            <div dir="rtl">
              <Loading />
            </div>
          ) : (
            <p className="text-right">{error}</p>
          )}
        </div>
      </div>
    </div>
    </RouteWithTitle>
  );
}

export default Contect;
